/**
 * FareCalendar — horizontal strip of ±7 days around the selected departure date.
 * Clicking a day re-runs the search for that date. Highlights selected + cheapest days.
 *
 * @param {Object} props
 * @param {import('../../mock/types').FareCalendarDay[]} props.days
 * @param {string} props.selectedDate ISO date currently selected.
 * @param {(date:string) => void} props.onSelect
 * @param {boolean} [props.loading]
 */
import React, { useEffect, useRef } from "react";
import "./fare-calendar.css";

const formatPrice = (amount, currency) =>
  `${currency} ${Math.round(amount).toLocaleString("en-PK")}`;

export default function FareCalendar({ days, selectedDate, onSelect, loading }) {
  const stripRef = useRef(null);
  const activeRef = useRef(null);

  // Center the selected day when it changes.
  useEffect(() => {
    if (activeRef.current && stripRef.current) {
      const el = activeRef.current;
      stripRef.current.scrollLeft =
        el.offsetLeft - stripRef.current.clientWidth / 2 + el.clientWidth / 2;
    }
  }, [selectedDate, days]);

  if (loading) {
    return (
      <div className="fcal fcal--loading">
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className="fcal__skeleton" />
        ))}
      </div>
    );
  }

  if (!days || days.length === 0) return null;

  return (
    <div className="fcal" ref={stripRef}>
      {days.map((d) => {
        const isSelected = d.date === selectedDate;
        return (
          <button
            type="button"
            key={d.date}
            ref={isSelected ? activeRef : null}
            className={`fcal__day ${isSelected ? "fcal__day--active" : ""} ${
              d.isCheapest ? "fcal__day--cheap" : ""
            }`}
            onClick={() => onSelect(d.date)}
          >
            <span className="fcal__weekday">{d.dayLabel}</span>
            <span className="fcal__price">{formatPrice(d.price, d.currency)}</span>
            {d.isCheapest && <span className="fcal__badge">Lowest</span>}
          </button>
        );
      })}
    </div>
  );
}
